import * as angular from 'angular';

import { IIdentifierQueryService } from '../../services/index';
import { ComponentDefinition, KeyValuePair } from '../../models';

class MultiQuerySelectorController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    items: { guid: string, name: string }[];
    model: any;// Type to be determined
    readonly name: string;
    readonly onChange?: (value: { model: { guid: string, name: string }[] }) => void;

    static $inject = ['identifierQueryService'];

    constructor(private _service: IIdentifierQueryService) {
    }

    $onInit() {
        this._service.getAll()
            .then(data => {
                this.items = data.map(d => {
                    return {
                        guid: d.query.guid,
                        name: d.query.name
                    };
                });
            });
    }

    select($item: KeyValuePair<any, string>, $value) {
        if (this.onChange) {
            this.onChange({ model: this.model });
        }
    }
    remove() {
        if (this.onChange) {
            this.onChange({ model: this.model });
        }
    }
}

export const wtMultiQuerySelector: ComponentDefinition = {
    componentId: 'wtMultiQuerySelector',
    controller: MultiQuerySelectorController,
    template: require('./multiQuerySelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        name: '<?',
        onChange: '&?'
    }
};
